import { apiAthenas } from '@/services/api/apiAthenas'
import { User } from '@/types/User'

export async function getUsers(signal?: AbortSignal) {
  const { data } = await apiAthenas.get<User[]>('/users', {
    signal
  })
  return data
}
